import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function Tokonomics() {
  const location = useLocation();
  const tokenRef = useRef(null);
  useEffect(() => {
    const scrollToRef = (ref) => {
      if (ref.current) {
        ref.current.scrollIntoView({ behavior: "smooth" });
      }
    };
    switch (location.hash) {
      case "#tokenomics":
        scrollToRef(tokenRef);
        break;
      default:
        break;
    }
  }, [location.hash]);

  return (
    <>
      <div className="container pt-5 pb-3" ref={tokenRef}>
        <div className="row ">
          <div className="col-md-10 m-auto">
            <div className="  text-center">
              <h2 className="hadding hadding_bg d-inline-block mb-0 fw300 pt-4 pb-4" data-aos="fade-up">
                Supply is 1,350,000,000
              </h2>
            </div>

            <div className="border_all mt-5 " data-aos="fade-up">
              <div className="row ">
                <div className="col-md-4 br">
                  <img
                    src="/assets/img/tokenomicsi.png"
                    alt="Tokenomics"
                    className="img-fluid "
                  />
                </div>
                <div className="col-md-8  ps-0">
                  <div className="d-lg-flex tokenomics_top align-items-center hadding_bg  text-center   justify-content-around">
                    <h2 className="hadding  d-inline-block mb-2 mb-lg-0 fw300 ">
                      Tokenomics
                    </h2>
                    <div>
                      <img
                        src="/assets/img/hi1.png"
                        alt="hero"
                        className="img-fluid "
                      />
                      <img
                        src="/assets/img/hi2.png"
                        alt="hero"
                        className="img-fluid"
                      />
                      <img
                        src="/assets/img/hi3.png"
                        alt="hero"
                        className="img-fluid "
                      />
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-lg-6 pe-lg-0">
                      <div className="d-flex border_box br br_re_none bb p-3 position-relative     ">
                        <img
                          src="/assets/img/paw.png"
                          alt="hero"
                          className="img-fluid mb-auto"
                        />
                        <h5 className="ps-3 mb-0">
                          Presale
                          <span className="color1 tonen_value">
                            405,000,000
                          </span>
                          <b className="color1 pre-text">30%</b>
                        </h5>
                      </div>
                    </div>
                    <div className="col-lg-6  ps-lg-0">
                      <div className="d-flex border_box  p-3  position-relative bb  ">
                        <img
                          src="/assets/img/paw.png"
                          alt="hero"
                          className="img-fluid mb-auto"
                        />
                        <h5 className="ps-3 mb-0">
                          Marketing
                          <span className="color1 tonen_value">
                            337,500,000
                          </span>
                          <b className="color1 pre-text">25%</b>
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-lg-6 pe-lg-0">
                      <div
                        className="d-flex border_box br br_re_none bb p-3 position-relative      "
                        style={{ "minHeight": "105px;" }}
                      >
                        <img
                          src="/assets/img/paw.png"
                          alt="hero"
                          className="img-fluid mb-auto"
                        />
                        <h5 className="ps-3 mb-0">
                          DEX liquidy and Listings
                          <span className="color1 tonen_value">
                            337,500,000
                          </span>
                          <b className="color1 pre-text">25%</b>
                        </h5>
                      </div>
                    </div>
                    <div className="col-lg-6  ps-lg-0">
                      <div
                        className="d-flex border_box  p-3  position-relative bb "
                        style={{ "minHeight": "105px" }}
                      >
                        <img
                          src="/assets/img/paw.png"
                          alt="hero"
                          className="img-fluid mb-auto"
                        />
                        <h5 className="ps-3 mb-0">
                          Rewards
                          <span className="color1 tonen_value">
                            135,000,000
                          </span>
                          <b className="color1 pre-text">10%</b>
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-lg-12  ">
                      <div className="d-flex border_box      p-3 position-relative  ">
                        <img
                          src="/assets/img/paw.png"
                          alt="hero"
                          className="img-fluid mb-auto"
                        />
                        <h5 className="ps-3 mb-0">
                          Future Development Fund
                          <span className="color1 tonen_value">
                            135,000,000
                          </span>
                          <b className="color1 pre-text">10%</b>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Tokonomics;
